import React,{useEffect} from 'react'; 
import Header from'./Components/Header';
import About from './Components/About';
import Features from './Components/Features';
import aboutimage from './utils/aboutgif.webp';
import './App.css'
import {BrowserRouter} from 'react-router-dom'
import Navbar from './Components/Navbar';
import Model1 from'./Components/Model1';
import Testimonial from './Components/Testimonial';
import Model4 from './Components/Model4';
import Footer from './Components/Footer'
import ReactGA from 'react-ga';

// const vercel_TRACKING_ID = "UA-254792243-1";
// ReactGA.initialize(vercel_TRACKING_ID)

const HOST_TRACKING_ID = "UA-254780089-1";
ReactGA.initialize(HOST_TRACKING_ID)
function App() {
  useEffect(()=>{
    let event=window.addEventListener("load",()=>{
      ReactGA.event({
          category: 'loaded',
          action: 'load',
      })
      return ()=>window.removeEventListener("load",event);
    })
  },[])
  return (
    <BrowserRouter>
    <div className="App">
      <Navbar/>
      <section id="header"><Header/></section>
      <section id="features"><Features/></section>
      {/* <section id="talk"><PromotionSections/></section> */}
      <section id="about"><About image={aboutimage} title='Our vision is to create the largest network of Kiranas which are equipped to serve the evolving needs of Indian consumers.' button='Get The APP'/></section>
      <section id="team">
        <Model1/>
      </section>
      <Model4/>
      <Testimonial/>
      <Footer />
    </div>
    </BrowserRouter>
  );
}

export default App;
